import styled from '@emotion/styled';

import { breakpoints, colors, fontSize } from '@datacamp/waffles-tokens';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  right: 0;
  z-index: 999;
  visibility: hidden;

  @media screen and (min-width: ${breakpoints.sm}) {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &.dc-is-visible {
    visibility: visible;
  }
`;

export const Flash = styled.div`
  align-items: center;
  display: flex;
  font-size: ${fontSize.h5};
  padding: 16px;
  pointer-events: auto;

  @media screen and (min-width: ${breakpoints.sm}) {
    border-radius: 0 0 4px 4px;
    max-width: 600px;
  }

  &.dc-flash--error {
    background-color: ${colors.red};
    color: ${colors.white};
  }

  &.dc-flash--success {
    background-color: ${colors.green};
    color: ${colors.white};
  }

  &.dc-flash--warning {
    background-color: ${colors.secondary};
    color: ${colors.white};
  }
`;

export const Content = styled.div`
  flex-grow: 1;
  padding: 0 16px;
  text-align: center;
`;

export const Close = styled.div`
  cursor: pointer;
  opacity: 0.65;
  padding-left: 16px;
  right: 16px;
  transition: opacity 0.3s cubic-bezier(0.77, 0, 0.175, 1);

  &:hover {
    opacity: 1;
  }

  @media screen and (min-width: ${breakpoints.sm}) {
    position: initial;
  }
`;
